/**
 * 充值提醒信息路由
 */
const RechargeNotifyRouter = {
  path: 'rechargeNotify',
  name: 'RechargeNotify',
  meta: {
    requiresAuth: false,
    leftMenu: true          // false表示不需要左边菜单栏
  },
  component: () => import('@/views/RechargeNotify/index')
}
export default RechargeNotifyRouter
